var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createJsonCommandExtractor } from './framework/JsonCommandExtractor';
import { NovastarHSeriesBase } from './util/NovastarHSeriesBase';
export class NovastarHSeriesTcp extends NovastarHSeriesBase {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        super(NovastarHSeriesTcp.driverType, state, log, framework);
        this.socket = socket;
    }
    // controls
    // phase callbacks
    // other class methods
    send(command, match, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.socket.send(command, (resp) => {
                return match(resp);
            }, tags, options);
            return resp;
        });
    }
}
// static properties
NovastarHSeriesTcp.driverType = 'socketDriver';
NovastarHSeriesTcp.key = '-NJ6nAHqPslQfVu9XvGs';
NovastarHSeriesTcp.socketOptions = [
    {
        commandExtractor: createJsonCommandExtractor({ nonJsonBehavior: 'ignore' }),
        parser: (command) => {
            try {
                const resp = JSON.parse(command);
                return resp;
            }
            catch (err) {
                return undefined;
            }
        },
        sendTerminator: '\r',
        port: 4999,
    },
];
